import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {isNumber} from '@aviary/store/common/typing.helpers';

@Component({
  selector: 'px-balance-table-amount-due-mobile',
  host: {class: 'w-full'},
  template: `
    <div class="w-full flex flex-col items-end min-h-20">
      @if (isNumber(amountDue)) {
        <div class="text-body-medium">Amount Due:</div>
        <div class="text-label-large" [class.text-error]="isNegative">{{ amountDue | format: 'POSITIVE_CURRENCY' }}</div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormatPipe]
})
export class BalanceTableAmountDueMobileColumnComponent {
  @Input() public amountDue: number | '';
  @Input() public isNegative: boolean;
  protected readonly isNumber = isNumber;
}
